import { render, staticRenderFns } from "./PersonSelector.vue?vue&type=template&id=6f3a125a&scoped=true"
import script from "./PersonSelector.vue?vue&type=script&lang=js"
export * from "./PersonSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a125a",
  null
  
)

export default component.exports